import * as React from 'react';
import './text.scss';

export const Text = (props) => {
	return <span>{props.children}</span>;
};
export default Text;
